import { SvgBase } from "../svg.base";

export const Plus = () => (
  <SvgBase width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <g fill="currentColor" fillRule="nonzero">
            <g>
                <g>
                    <path d="M19 13L13 13 13 19 11 19 11 13 5 13 5 11 11 11 11 5 13 5 13 11 19 11z" transform="translate(-605 -833) translate(504 825) translate(101 8)"/>
                </g>
            </g>
        </g>
    </g>
  </SvgBase>
);